export enum ContractStatusEnum {
  Active = 1,
  Expired,
  Pendent,
  Canceled,
  Deleted,
  AwaitingPayment,
  NotApproved,
}
